
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"15","viewBox":"0 0 7 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.57 13.381l-.21.857c-.629.248-1.13.437-1.505.567-.374.13-.81.195-1.305.195-.761 0-1.353-.187-1.775-.557a1.802 1.802 0 01-.634-1.415c0-.22.015-.448.047-.68.032-.232.084-.494.153-.786l.786-2.781c.07-.267.13-.52.177-.758.048-.237.072-.455.072-.651 0-.356-.074-.604-.22-.744-.147-.139-.426-.21-.84-.21-.204 0-.413.033-.626.096a8.716 8.716 0 00-.55.18l.21-.857c.516-.21 1.008-.389 1.478-.538.47-.15.916-.224 1.336-.224.756 0 1.34.183 1.75.548.409.366.613.84.613 1.424 0 .12-.013.334-.042.638-.028.305-.08.585-.157.839l-.783 2.77a7.355 7.355 0 00-.172.763 3.926 3.926 0 00-.076.647c0 .368.082.62.246.753.166.133.451.2.856.2.19 0 .407-.034.648-.1a3.63 3.63 0 00.523-.176zm.198-11.63c0 .483-.182.896-.547 1.234-.365.34-.804.51-1.318.51-.516 0-.956-.17-1.325-.51a1.617 1.617 0 01-.552-1.233c0-.482.184-.895.552-1.238C3.946.17 4.388 0 4.903 0c.514 0 .953.172 1.318.514.366.343.547.756.547 1.238z","fill":"#E2E8F0"}})])
          )
        }
      }
    